export default "__VITE_ASSET__BrafCJCY__"